// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__3BBhl","toolbar":"Text_toolbar__1k7x-","toolbarButton":"Text_toolbarButton__2NWHc","editor":"Text_editor__2Ckem","flex1":"Text_flex1__1Ov1P"};